export default __webpack_public_path__ + "static/orange-white-7eb126dccf1eebd99aa61b1a40f65977.png";